import React from 'react';
import FeatureCards from "../../components/FeatureCards/FeatureCards";
import CTA from "../../components/Constant/cta/CTA";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import WhySection from "../../components/WhySection/WhySection";
import LocationTimeline from "../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../components/IntroSection/IntroSection";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../components/ServiceCards/ServiceCards ";
import ComparisonTable from "../../components/ComparisonTable/ComparisonTable";

export default function CyprusJurisdiction() {

    return (
        <main className='main'>
            <IntroSection
                title="Cyprus Jurisdiction"
                subtitle="A Leading EU Hub for Forex, FinTech, and Crypto Licensing"
                description="Cyprus has grown into one of the most important EU financial services jurisdictions, attracting hundreds of forex brokers, fintech companies, and crypto platforms. Regulated by the Cyprus Securities and Exchange Commission (CySEC) and the Central Bank of Cyprus, it offers EU credibility at lower costs than Malta or Luxembourg. Cyprus is best known as the #1 EU jurisdiction for forex brokers (CIF licenses), but it also supports banking, EMI, insurance, funds, and crypto licensing."
                badges={[
                    "EU Member State",
                    "MiFID II Passporting",
                    "FinTech-Friendly",
                    "12.5% Corporate Tax"
                ]}
                buttonText="Request a Cyprus Licensing Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../assets/images/jurisdictions/cyprus.png")}
                imageAlt="Cyprus Financial & Licensing Jurisdiction"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title="Why Choose Cyprus?"
                        blocks={[
                            {
                                items: [
                                    { text: "EU Credibility — full EU recognition under CySEC and Central Bank oversight." },
                                    { text: "MiFID II Passporting — investment firms licensed in Cyprus can operate across the entire EEA." },
                                    { text: "Forex Hub — most EU forex brokers are licensed in Cyprus due to lower setup costs than Malta." },
                                    { text: "Payments & FinTech Growth — rising number of EMI and PSP licenses." },
                                    { text: "Crypto-Friendly — CASP registration for exchanges, wallets, custody, and token platforms." },
                                    { text: "Attractive Tax Regime — 12.5% corporate tax + double taxation treaties." },
                                    { text: "Insurance & Funds — aligned with EU Solvency II and AIFMD/UCITS." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Key Licensing Sectors in Cyprus"
                        blocks={[
                            {
                                title: "Brokerage & Forex (CIF License)",
                                items: [
                                    { text: "Cyprus is the forex capital of the EU." },
                                    { text: "Cyprus Investment Firm (CIF) license under MiFID II." },
                                    { text: "Covers forex, CFDs, portfolio management, investment advice." },
                                    { text: "Capital requirements from €75,000 to €750,000." }
                                ]
                            },
                            {
                                title: "Banking",
                                items: [
                                    { text: "Full Credit Institution License from the Central Bank of Cyprus." },
                                    { text: "Allows deposit-taking, lending, IBAN/SWIFT services." },
                                    { text: "Capital requirement: €5,000,000+." }
                                ]
                            },
                            {
                                title: "Payments & EMI",
                                items: [
                                    { text: "Payment Institution (PI) and Electronic Money Institution (EMI) licenses." },
                                    { text: "Capital requirement: €125,000 (PI) | €350,000 (EMI)." },
                                    { text: "Passporting rights across the EU." }
                                ]
                            },
                            {
                                title: "Crypto & Blockchain (CASP)",
                                items: [
                                    { text: "CASP Registration under CySEC." },
                                    { text: "Covers crypto exchanges, wallets, custody, token issuance." },
                                    { text: "Capital requirement: €50,000–€750,000 depending on activity." }
                                ]
                            },
                            {
                                title: "Insurance & Reinsurance",
                                items: [
                                    { text: "Regulated under Solvency II." },
                                    { text: "Life, non-life, captives, and reinsurance companies." },
                                    { text: "Capital requirement: €2,500,000–€3,700,000." }
                                ]
                            },
                            {
                                title: "Funds & Asset Management",
                                items: [
                                    { text: "UCITS (retail funds) with EU passporting." },
                                    { text: "AIF/AIFM (Alternative Investment Funds) for professionals." },
                                    { text: "PIF (lighter regime for HNWIs)." },
                                    { text: "Capital requirement: €125,000–€300,000+." }
                                ]
                            },
                            {
                                title: "Gaming",
                                items: [
                                    { text: "Regulated by the National Betting Authority (NBA)." },
                                    { text: "Covers sports betting (online & land-based)." },
                                    { text: "❌ Online casino/poker not fully regulated (operators prefer Malta or Curaçao)." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Benefits of Cyprus Jurisdiction"
                        blocks={[
                            {
                                items: [
                                    { text: "EU recognition + passporting rights." },
                                    { text: "Forex powerhouse — home to leading global brokers." },
                                    { text: "Lower costs & faster licensing compared to Malta." },
                                    { text: "Banking & PSP-friendly — widely accepted by liquidity providers." },
                                    { text: "Attractive tax regime — 12.5% corporate tax, one of the lowest in the EU." },
                                    { text: "Growing fintech & crypto hub — ideal for startups expanding into EU markets." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Challenges to Consider"
                        blocks={[
                            {
                                items: [
                                    { text: "Capital Requirements — €75k–€750k for CIF, €350k for EMI, €5M+ for banking." },
                                    { text: "Timelines — 6–12 months for most licenses." },
                                    { text: "Strict Compliance — AML/KYC obligations and ongoing audits." },
                                    { text: "Gaming Limitation — no full online casino licensing." }
                                ]
                            }
                        ]}
                    />

                    <ComparisonTable
                        title="Cyprus vs Offshore Jurisdictions"
                        columns={columns}
                        data={data}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Specialists in CySEC and Central Bank licensing" },
                                { text: "End-to-end service: incorporation, compliance, licensing, audits" },
                                { text: "Guidance on forex, EMI, crypto, and fund structures" },
                                { text: "Introductions to banking partners, PSPs, and liquidity providers" },
                                { text: "Balanced advice: Cyprus vs Malta vs Offshore options" }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking for EU recognition with lower costs than Malta?"
                        description="Cyprus offers forex, EMI, crypto, banking, and fund licenses with full EU credibility and passporting rights."
                        buttonText="Book a Cyprus Licensing Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Why is Cyprus popular for forex?",
        answer: "Cyprus has lower costs than Malta and is the main EU hub for forex brokers.",
    },
    {
        question: "What is the corporate tax rate?",
        answer: "12.5% — one of the lowest in the EU.",
    },
    {
        question: "Can Cyprus companies passport services across the EU?",
        answer: "Yes — MiFID II, PSD2, AIFMD, and Solvency II all provide EEA-wide recognition.",
    },
    {
        question: "Is Cyprus good for crypto?",
        answer: "Yes — CASP registration allows crypto exchanges, wallets, and custodians.",
    },
    {
        question: "What about gaming?",
        answer: "Only sports betting is regulated. Online casino operators typically prefer Malta.",
    },
];

const testimonialsData = [
    {
        quote: "Our forex brokerage was licensed under CySEC with Offshore Advisory. The process was complex, but now we serve clients across the EU.",
        author: "Mark L.",
        role: "FX Broker CEO"
    },
    {
        quote: "We obtained a Cyprus EMI license with Offshore Advisory. Excellent guidance through Central Bank and banking integration.",
        author: "Elena K.",
        role: "FinTech Founder"
    }
];


const columns = [
    "feature",
    "Cyprus (EU)",
    "Malta (EU)",
    "Mwali (Comoros)",
    "Anjouan (Comoros)",
    "Western Sahara"
];

const data = [
    {
        feature: "Recognition",
        "Cyprus (EU)": "Tier-1 EU",
        "Malta (EU)": "Tier-1 EU",
        "Mwali (Comoros)": "Offshore",
        "Anjouan (Comoros)": "Offshore",
        "Western Sahara": "Offshore",
    },
    {
        feature: "Setup Time",
        "Cyprus (EU)": "6–12 months",
        "Malta (EU)": "6–12 months",
        "Mwali (Comoros)": "2–3 weeks",
        "Anjouan (Comoros)": "4–8 weeks",
        "Western Sahara": "1–2 weeks",
    },
    {
        feature: "Capital Requirement",
        "Cyprus (EU)": "€50k–€5M+",
        "Malta (EU)": "€50k–€5M+",
        "Mwali (Comoros)": "$50k–250k+",
        "Anjouan (Comoros)": "None",
        "Western Sahara": "None",
    },
    {
        feature: "Cost Level",
        "Cyprus (EU)": "Medium–High",
        "Malta (EU)": "High",
        "Mwali (Comoros)": "Medium",
        "Anjouan (Comoros)": "Low",
        "Western Sahara": "Low",
    },
    {
        feature: "Best For",
        "Cyprus (EU)": "Forex, EMI, Crypto",
        "Malta (EU)": "Gaming, EMI, Funds",
        "Mwali (Comoros)": "Offshore brokers, banks",
        "Anjouan (Comoros)": "Crypto & gaming startups",
        "Western Sahara": "Multi-sector startups",
    },
];